<template>
    <card :to="$config.public.isSpoferanDomain ? $app('sports-sport', {params: {sport: sport._key}, state: {sport_ts: $date(sport.updated_at).unix()}}) : $spoferanUrl(`/sports/${sport._key}`)"
		  :class="{'is-clicked': isClicked}"
		  class="sport-preview" @click="isClicked = true"
		  v-bind="cardProps">
        <card-image v-if="sport.image" :src="sport.image" :alt="sport.title" :size="{width: '100vw', md: {width: 760}}" :ratio="16/9" class="sport-preview-image"/>
        <card-title class="sport-preview-title">{{ sport.title }}</card-title>

		<card-text class="pb-8">
			<span class="truncate-5-lines sport-preview-description">{{ sport.preview_text }}</span>
		</card-text>
        <card-buttons left>
            <chip v-if="sport.clubs_count" small class="mr-4">{{ $t('param_label.clubs', sport.clubs_count) }}</chip>
            <chip v-if="sport.users_count" small>{{ $t('param_label.athletes', sport.users_count) }}</chip>
        </card-buttons>
    </card>
</template>

<script>
import CardMixin from "../Card/CardMixin";
    export default {
        name: 'SportTypeCard',

        mixins: [CardMixin],

        props: {

            // The sport type object to display
            sport: {
                type: Object,
                required: true
            }
        },

		data() {
			return {
				isClicked: false,
			}
		},
    }
</script>

<style>
.sport-preview.is-clicked .sport-preview-image img {
  view-transition-name: sport-image;
}
.sport-preview.is-clicked .sport-preview-title {
  view-transition-name: sport-title;
}
.sport-preview.is-clicked .sport-preview-description {
  view-transition-name: sport-description;
}
</style>
